import React from "react";
import styled from "styled-components";
import BurgerMenu from "./common/burger";

const Header = () => {
  const [activeSection, setActiveSection] = React.useState('inicio');

  React.useEffect(() => {
    const handleScroll = () => {
      const sections = ['inicio', 'soluciones-hormigon', 'servicios', 'process', 'contacto'];
      const scrollPosition = window.scrollY + 120; // Increased threshold slightly

      // Detection for bottom of page to ensure 'contacto' becomes active
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50) {
        setActiveSection('contacto');
        return;
      }

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          const offsetTop = rect.top + window.scrollY;
          const height = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + height) {
            setActiveSection(section);
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const rect = element.getBoundingClientRect();
      const offsetTop = rect.top + window.scrollY - 90; // Adjust for header height
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <HeaderWrapper>
      <HeaderContainer>
        <Logo src="/logo.png" alt="Comber Logo" onClick={(e) => handleNavClick(e, 'inicio')} style={{ cursor: 'pointer' }} />

        <HeaderNav>
          <HeaderNavLink
            href="#inicio"
            className={activeSection === 'inicio' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'inicio')}
          >
            Inicio
          </HeaderNavLink>
          <HeaderNavLink
            href="#soluciones-hormigon"
            className={activeSection === 'soluciones-hormigon' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'soluciones-hormigon')}
          >
            Soluciones en Hormigón
          </HeaderNavLink>
          <HeaderNavLink
            href="#servicios"
            className={activeSection === 'servicios' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'servicios')}
          >
            Servicios de construcción
          </HeaderNavLink>
          <HeaderNavLink
            href="#contacto"
            className={activeSection === 'contacto' ? 'active' : ''}
            onClick={(e) => handleNavClick(e, 'contacto')}
          >
            Contacto
          </HeaderNavLink>
        </HeaderNav>

        <BurgerContainer>
          <BurgerMenu />
        </BurgerContainer>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default Header;

/* ================= ESTILOS ================= */

const HeaderWrapper = styled.header`
  background-color: var(--primary-color);
  box-shadow: var(--shadow-md);
  height: 90px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 80px;

  @media (max-width: 600px) {
    padding: 0 20px;
    justify-content: space-between;
    }

`;

const Logo = styled.img`
  height: 34px;
  width: auto;
  object-fit: contain;

  @media (max-width: 600px) {
    height: 30px;
  }
  @media (max-width: 425px) {
    height: 25px;
  }
`;

const HeaderNav = styled.nav`
  display: flex;
  gap: 50px;

  @media (max-width: 1200px) {
    display: none;
  }
`;

const BurgerContainer = styled.div`
  display: none;

  @media (max-width: 1200px) {
    display: block;
  }
`;

const HeaderNavLink = styled.a`
  color: var(--text-light);
  text-decoration: none;
  font-weight: 600;
  font-family: var(--font-text);
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: var(--secondary-color);
    transition: width 0.3s ease;
  }

  &:hover {
    color: var(--secondary-color);

    &::after {
      width: 100%;
    }
  }

  &.active {
    &::before {
      content: "•";
      color: var(--secondary-color);
      position: absolute;
      left: -20px;
    }
  }
`;
